import type { EmbedConfig } from './urlGenerator';

export interface DashboardStateSnapshot {
  partnerKey: string;
  affiliateRfsn?: string;
  configuringProductTag?: string;
  config: EmbedConfig;
}

function isDashboardStateSnapshot(
  value: unknown
): value is DashboardStateSnapshot {
  if (!value || typeof value !== 'object') return false;

  const candidate = value as Partial<DashboardStateSnapshot>;
  return (
    typeof candidate.partnerKey === 'string' &&
    !!candidate.partnerKey &&
    !!candidate.config &&
    typeof candidate.config === 'object'
  );
}

export function encodeDashboardState(state: DashboardStateSnapshot): string {
  return btoa(JSON.stringify(state));
}

export function decodeDashboardState(
  encoded: string | null
): DashboardStateSnapshot | null {
  if (!encoded) return null;

  try {
    const parsed = JSON.parse(atob(encoded));
    return isDashboardStateSnapshot(parsed) ? parsed : null;
  } catch (error) {
    console.warn('Failed to decode dashboard state from URL', error);
    return null;
  }
}

export function parseDashboardStateFromSearch(
  search: string = window.location.search
): DashboardStateSnapshot | null {
  const params = new URLSearchParams(search);
  return decodeDashboardState(params.get('ds'));
}

export function buildDashboardStateUrl(
  baseUrl: string,
  state: DashboardStateSnapshot
): string {
  const url = new URL(baseUrl || window.location.href, window.location.href);
  url.searchParams.set('ds', encodeDashboardState(state));
  return url.toString();
}

export function clearDashboardStateFromCurrentUrl() {
  const url = new URL(window.location.href);
  url.searchParams.delete('ds');
  window.history.replaceState({}, '', url.toString());
}
